module.exports = __webpack_public_path__ + "img/operate-num-bg.2eaa0615.png";